module.exports = __webpack_public_path__ + "media/34.fd970ec8.mp3";